import lf from 'lovefield';
import {thanksLogDB,tableNames} from '../indexedDB/lovefield.js';

import moment from 'moment';

export default class Thanks {

    static getAllThanksOrderByDate(){
        return new Promise(function(resolve,reject){

            try{
                const thanksTable = thanksLogDB.getSchema().table(tableNames.thanks);
                const membersTable = thanksLogDB.getSchema().table(tableNames.members);

                const getAllQuery = thanksLogDB.select()
                                               .from(thanksTable)
                                               .leftOuterJoin(membersTable,membersTable.id.eq(thanksTable.member_id))
                                               .orderBy(thanksTable.date,lf.Order.DESC)
                                               .orderBy(thanksTable.id,lf.Order.DESC);
                getAllQuery.exec().then((result) => {
                    resolve({
                        status:true,
                        data:result
                    })
                })

            }catch(e){                 
                reject({
                    status:false,
                    message:'get error'
                })
            }
            
        })
    }

    static getThanksByMember(memberId) {
        return new Promise ((resolve,reject) => {
            try {
                const thanksTable = thanksLogDB.getSchema().table(tableNames.thanks);

                const getQuery = thanksLogDB.select()
                                            .from(thanksTable)
                                            .where(thanksTable.member_id.eq(lf.bind(0)))
                                            .orderBy(thanksTable.date,lf.Order.DESC)
                                            .orderBy(thanksTable.id,lf.Order.DESC);
                getQuery.bind([memberId]).exec().then((result) => {

                    //データ表示に必要な形に成形
                    const allThanksNumber = result.length;

                    const checkedThanksNumber = result.filter((value) => {
                        return value.check === true;
                    }).length;
                    
                    const thanksPercent = parseInt((checkedThanksNumber / allThanksNumber) * 100);
                    
                    resolve({
                        status:true,
                        data:{
                            allThanksNumber,
                            checkedThanksNumber,
                            thanksPercent,
                            latestThanks:result[0]
                        }
                    })

                }).catch((error) => {
                    reject({
                        status:false,
                        message:'thanks by member get error'
                    })
                })
                
            }catch(e){
                reject({
                    status:false,
                    message:'thanks by member get error'
                })
            }
        })
    }

    static getYearList() {
        return new Promise ((resolve,reject) => {
            try {
                const thanksTable = thanksLogDB.getSchema().table(tableNames.thanks);
                let getAllQuery = thanksLogDB.select()
                                                .from(thanksTable)
                                                .orderBy(thanksTable.date,lf.Order.ASC);
                getAllQuery.exec().then((result) => {
                    //dateのみの配列に
                    const onlyDateArray = result.map((value) => {
                        const date = value.date;
                        const year = date.substr(0, 4);
                        return year
                    })

                    //重複を削除
                    const yearArray = onlyDateArray.filter(function (value, index, self) {
                        return self.indexOf(value) === index;
                    });
                    
                    resolve({
                        status:true,
                        data:yearArray
                    })

                })
            }catch(e) {
                reject({
                    status:false,
                    message:'yearList get error'
                })
            }
        })
    }

    static getSortedThanks(sortObj) {
        return new Promise (function(resolve,reject){            
            try {
                const thanksTable = thanksLogDB.getSchema().table(tableNames.thanks);
                const membersTable = thanksLogDB.getSchema().table(tableNames.members);

                //addへの引数（絞り込み用）を決定。それぞれ、絞り込む場合は引数に加えていく。
                let andArgumentArray = [];

                //バインド変数を格納する配列を設定
                let bindElementArray = [];

                //メンバー
                if(sortObj.memberId !== 0){
                    andArgumentArray.push( thanksTable.member_id.eq( lf.bind(bindElementArray.length) ) )
                    bindElementArray.push(sortObj.memberId)
                }

                //thanksCheckの値を検索用に定義し直す
                if(sortObj.thanksCheck === 'checked'){
                    sortObj.thanksCheck = true;
                }else if(sortObj.thanksCheck === 'unchecked'){
                    sortObj.thanksCheck = false;
                }

                //ありがとチェック
                if(sortObj.thanksCheck !== 'all'){
                    // andArgumentArray.push(thanksTable.check.eq(thanksCheckValue))
                    andArgumentArray.push( thanksTable.check.eq( lf.bind(bindElementArray.length) ) );
                    bindElementArray.push(sortObj.thanksCheck)
                }

                let getSortedQuery = thanksLogDB.select()
                                                .from(thanksTable)
                                                .leftOuterJoin(membersTable,membersTable.id.eq(thanksTable.member_id))
                                                .orderBy(thanksTable.date,lf.Order.DESC)
                                                .orderBy(thanksTable.id,lf.Order.DESC);
                                                
                //絞り込みがあれば絞り込みを加える
                if(andArgumentArray.length !== 0){
                    getSortedQuery = getSortedQuery.where(lf.op.and(...andArgumentArray))
                                     .bind(bindElementArray);
                }

                getSortedQuery.exec().then((result) => {

                    //クエリ発行でのdate絞り込みができなかったため（substrが使えなかった）ここで行う
                    if(sortObj.year !== 0){
                        result = result.filter((value) => {
                            return value.Thanks.date.substr(0,4) === sortObj.year;
                        })                        
                    }

                    if(sortObj.month !== 0){
                        result = result.filter((value) => {
                            return value.Thanks.date.substr(4,2) === sortObj.month;
                        })                        
                    }

                    resolve({
                        status:true,
                        data:result
                    })
                }).catch(() => {
                    reject({
                        status:false,
                        message:'sorted thanks get error'
                    })
                })

            }catch(e) {
                reject({
                    status:false,
                    message:'sorted thanks get error'
                })
            }
        })
    }

    static getSpecificThank(id) {
        return new Promise (function(resolve,reject){
            try {
              
                const thanksTable = thanksLogDB.getSchema().table(tableNames.thanks);
                const membersTable = thanksLogDB.getSchema().table(tableNames.members);
                
                const getSpecificQuery = thanksLogDB.select()
                                                    .from(thanksTable)
                                                    .leftOuterJoin(membersTable,membersTable.id.eq(thanksTable.member_id))
                                                    .where(thanksTable.id.eq(id));

                getSpecificQuery.exec().then((result) => {
                    resolve({
                        status:true,
                        data:result[0]
                    })
                })

            }catch(e){                 
                reject({
                    status:false,
                    message:'get error'
                })
            }
        })
    }

    static makeThanksWithDateByIntStr(thankData) {
        //Date型の日付を整数列（string）のYYYYMMDDに変換
        // const dateByInt = parseInt( moment(thankData.date).format('YYYYMMDD') );
        const dateByIntStr = moment(thankData.date).format('YYYYMMDD');

        //thankDataを更新して返す
        thankData.date = dateByIntStr;

        return thankData;
    }

    static postThank(thankData) {
        return new Promise (function(resolve,reject){

            //時間切り捨て
            thankData = Thanks.makeThanksWithDateByIntStr(thankData);

                        
            try {
                const thanksTable = thanksLogDB.getSchema().table(tableNames.thanks);

                const thankToPost = thanksTable.createRow(thankData);

                const postQuery = thanksLogDB.insertOrReplace()
                                             .into(thanksTable)
                                             .values([thankToPost]);  
                postQuery.exec().then((result) => {

                    resolve({
                        status:true,
                        data:result[0]
                    })

                })           

            }catch(e){
                reject({
                    status:false,
                    message:'post error'
                })
            }
        })
    }

    // @param Thanks.id{Int}
    static deleteMember(id) {
        return new Promise(function(resolve,reject){

            try{

                const thanksTable = thanksLogDB.getSchema().table(tableNames.thanks);

                const deleteQuery = thanksLogDB.delete()
                                               .from(thanksTable)
                                               .where(thanksTable.id.eq(id));                

                deleteQuery.exec().then((result) => {

                    resolve({
                        status:true,
                        data:result[0]
                    })
                });

            }catch(e){                 
                reject({
                    status:false,
                    message:'post error'
                })
            }
        })
    }

}